import React from 'react';
import { connect } from 'react-redux';
import axios from 'axios'
import Protected from '../../layout/protected';
import OnlyClassroom from '../../layout/only-classroom';
import OnlyCore from '../../layout/only-core';

import ArticleURLForm from './article-url-form';
import { ArticleListMostFisked, ArticleListMostRecent, ArticleListArticlesInMyCourses } from './article-lists';

import { temporaryAccessToken } from '../../../config/app';
import { getUserCourses, addCourse, getAllCourses, addMember} from '../../../utils/apiRequests';
import { setAccountSettingsData, setAllCourses, setArticleUrl, setCourseValue, setCurrentUser, setCurrentUserCourses, setInputValue, setNewCourse, setShowEditField, setActiveTab, toggleFocused, showVideos, closeVideos} from '../../../actions';
import fiskkitredblacklogo from '../../../resources/img/Core_logo.png';
import styles from './home.module.scss';

interface IHomeProps {
  accountSettingsData: any;
  allCourses: any;
  app: any;
  articleUrl: string;
  courseValue: any;
  error: any;
  focused: any;
  history: any;
  newCourse: string;
  showMostFisked: any;
  showMostRecent: any;
  sidebarOpen: any;
  courseData: string;
  currentUser: {};
  currentUserCourses: any;

  setAccountSettingsData(updatedAccountSettings: any): void;
  setAllCourses(allCoursesArray: any): void;
  setArticleUrl(url: string): void;
  setCourseValue(courseValue: any): void;
  setCurrentUser(userData: {}): void;
  setCurrentUserCourses(courses: []): void;
  setInputValue(inputValue): void;
  setNewCourse(newCourse: {}): void;
  setShowMostFisked(value: boolean): void;
  setShowEditField(data: {}): void;
  setShowMostRecent(value: boolean): void;
  setSortBy(activeTab: string): void;
  toggleFocused(): void;

}

export class Home extends React.Component<IHomeProps | any, any, any> {

  public componentDidMount() {
    if (this.props.app.APP_EXPERIENCE === 'core') {
      this.props.setActiveTab('most-recent');
    }

    // if user is Student
    if (this.props.app.APP_EXPERIENCE === 'classroom' && this.props.currentUser.is_instructor === 0) { // true || for testing
      // get all courses
      getAllCourses()
        .then((resp) => {
          // prepare all courses object
          const allCourses = resp.data.courses;
          // setAll courses to the Store property
          this.props.setAllCourses(allCourses);
        })
    }

    // reset showing the Location Edit field variable to false:
    const boolValue = false;
    const dataLocation = {
      name: 'showLocationEdit',
      value: boolValue,
    }
    this.props.setShowEditField(dataLocation);

    // reset showing the Bio Edit field variable to false:
    const dataBio = {
      name: 'showBioEdit',
      value: boolValue,
    }
    this.props.setShowEditField(dataBio);

  }

  public handleChange = (event) => {
    const articleUrl = event.target.value;
    this.props.setArticleUrl(articleUrl);
  }

  public handleFocus = () => {
    this.props.toggleFocused();
    // this.props.toggleProperty("focused");
  }


  public handleFiskkitSubmit = async (e) => {
    e.preventDefault();
    // prepare urls
    const targetUrl = this.props.articleUrl;
    // const requestUrl = "https://developer-api.fiskkit.com/api/v1/articles";
    const API_HOST = this.props.app.API_HOST;
    // the production endpoint
    const requestUrl = `${API_HOST}/api/v1/articles`;
    // only for testing:
    const proxyurl = 'https://cors-anywhere.herokuapp.com/';
    const corsUrl = proxyurl + requestUrl;
    const token = localStorage.getItem('fiskkit.access_token')
      || temporaryAccessToken;
    // "NkeyxK6kG16MpidiJdtZuXYNiJlRwoLr5oDHykGe"

    // create payload to send in body of request
    const data = {
      url: targetUrl,
    };
    const headers = {
      // 'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };

    // define function
    const recursiveResponse = async () => {
      const res = await axios.post(requestUrl, data, { headers });

      if (
        res.data.article_id
        && res.data.article_id !== null
        && res.data.article_id !== undefined
      ) {
        // redirect user
        this.props.history.push(`/article/${res.data.article_id}/discuss`);
      } else {
        // make request again
        recursiveResponse();
      }
    };
    // run the function
    await recursiveResponse();
  }

  public handleCourseChange = (e) => {
    e.preventDefault();
    const value = e.target.value;
    // set the value
    this.props.setCourseValue(value);
  }

  public handleCourseSelect = (e) => {
    e.preventDefault();
    // define course id
    const courseId = {
      courseId: this.props.courseValue
    }
    // add member POST
    addMember(courseId)
      .then((resp) => {
        setTimeout(() => {
          getUserCourses(this.props.currentUser.id)
            .then((resp) => {
              const currentUserCourses = resp.data.courses;
              // set courses array to the Redux Store
              this.props.setCurrentUserCourses(currentUserCourses);
            })
        }, 200)
      })
  }

  public handleCourseAdd = (e) => {
    e.preventDefault();
    // send data to db POST
    if (this.props.newCourse.trim() !== '') {
      const course = {
        course: this.props.newCourse,
      }
      addCourse(course)
        .then((resp) => {
          const userId = this.props.currentUser.id;
          // refresh courses data from db and render it
          getUserCourses(userId)
            .then((resp) => {
              const currentUserCourses = resp.data.courses;
              // set courses array to the Redux Store
              this.props.setCurrentUserCourses(currentUserCourses);
            })
        })
    } else {
    }
  }

  public handleEditField = (e) => {
    e.preventDefault();
    const fieldName = e.target.id;
    // set show value to true
    const boolValue = true;
    const data = {
      name: fieldName,
      value: boolValue,
    }
    this.props.setShowEditField(data);
  }

  public renderContent = () => (
    <div style={{ margin: '0px auto', maxWidth: '1200px' }}>
      <div className={styles.mainContent}>
        <div className="site-content">
          <div className="contanier contanier-md">
            <div className={styles.logoContainer}>
              <div
                style={{ margin: '0 auto' }}
              >
                <img
                  style={{ width: '186px' }}
                  src={fiskkitredblacklogo}
                />
              </div>
              <p
                className={styles.tagline}
              >
                A better way to discuss the news
              </p>
            </div>

            <ArticleURLForm />

            <div className={styles.tabContainer}>
              <ul className={styles.sortingTabs}>
                <OnlyClassroom>
                  <li
                    // tslint:disable-next-line:jsx-no-multiline-js
                    className={
                      `${this.props.activeTab === 'articles-in-my-courses' ? styles.active : ''}`}
                  >
                    <a
                      href="#"
                      className={styles.tab}
                      onClick={e => this.props.setActiveTab('articles-in-my-courses')}
                    >
                      My Course Articles
                    </a>
                  </li>
                </OnlyClassroom>
                <OnlyCore>
                  <li
                    // tslint:disable-next-line:jsx-no-multiline-js
                    className={
                      `${this.props.activeTab === 'most-recent' ? styles.active : ''}`}
                  >
                    <a
                      href="#"
                      className={styles.tab}
                      onClick={e => this.props.setActiveTab('most-recent')}
                    >
                      Most Recent
                    </a>
                  </li>
                  <li
                    // tslint:disable-next-line:max-line-length
                    className={`${this.props.activeTab === 'most-fisked' ? styles.active : ''}`}
                  >
                    <a
                      href="#"
                      className={styles.tab}
                      onClick={e => this.props.setActiveTab('most-fisked')}
                    >
                      Most Fisked
                    </a>
                  </li>
                </OnlyCore>
              </ul>
            </div>
            <div />

            {/* tslint:disable-next-line:jsx-no-multiline-js */}
            {
              this.props.activeTab === 'most-recent'
              && <div className={styles.fisksList}>
                {/* tslint:disable-next-line:max-line-length */}
                <ArticleListMostRecent

                />
              </div>}
            {/* tslint:disable-next-line:jsx-no-multiline-js */}
            {
              this.props.activeTab === 'most-fisked'
              && <div className={styles.fisksList}>
                <ArticleListMostFisked

                />
              </div>}
            <OnlyClassroom>
            {
              this.props.activeTab === 'articles-in-my-courses'
              && <div className={styles.fisksList}>
                <ArticleListArticlesInMyCourses

                />
              </div>
            }

            </OnlyClassroom>
            <div />
          </div>
        </div>
      </div>
    </div>
  )

  public render() {
    return (
      this.props.app.APP_EXPERIENCE === 'classroom'
      ? <Protected>{this.renderContent()}</Protected>
      : this.renderContent()
    );
  }
}

const mapStateToProps = (state) => {
  return {
    accountSettingsData: state.home.accountSettingsData,
    allCourses: state.home.allCourses,
    app: state.app,
    articleUrl: state.home.articleUrl,
    courseData: state.home.courseData,
    courseValue: state.home.courseValue,
    currentUser: state.home.currentUser,
    userIntro: state.user,
    show_videos : state.videos.show_videos,
    currentUserCourses: state.home.currentUserCourses,
    error: state.home.error,
    focused: state.home.focused,
    newCourse: state.home.newCourse,
    showBioEdit: state.home.showBioEdit,
    showLocationEdit: state.home.showLocationEdit,
    showMostFisked: state.home.showMostFisked,
    showMostRecent: state.home.showMostRecent,
    sidebarOpen: state.home.sidebarOpen,
    activeTab: state.home.activeTab,
    isLoggedIn: state.auth.access_token ? true : false,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setAccountSettingsData: (updatedSettings) => { dispatch(setAccountSettingsData(updatedSettings)); },
    setAllCourses: (allCoursesArray) => { dispatch(setAllCourses(allCoursesArray)); },
    setArticleUrl: (articleUrl) => { dispatch(setArticleUrl(articleUrl)); },
    setCourseValue: (courseValue) => { dispatch(setCourseValue(courseValue)); },
    setCurrentUser: (userData) => { dispatch(setCurrentUser(userData)); },
    setCurrentUserCourses: (coursesArray) => { dispatch(setCurrentUserCourses(coursesArray)); },
    setInputValue: (inputValue) => { dispatch(setInputValue(inputValue)); },
    setNewCourse: (newCourse) => { dispatch(setNewCourse(newCourse)); },
    setShowEditField: (data) => { dispatch(setShowEditField(data)); },
    setActiveTab: (activeTab) => { dispatch(setActiveTab(activeTab)); },
    toggleFocused: () => { dispatch(toggleFocused()); },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
